var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('link',{attrs:{"href":_vm.fontUrl,"rel":"stylesheet"}}),_c('kf-wc-child-benefit-calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }